import React, { useContext, useEffect } from "react";

import TodoListRectangle from "../elements/TodoListRectangle";
import { TodoListDataContext } from "../contexts/TodoListData";
import { LayerDataContext } from "../contexts/LayerData";

const TodoListManager = () => {
  const { todoListData, setTodoListData } = useContext(TodoListDataContext);
  const { currentPathIndex, currentPath } = useContext(LayerDataContext);

  // useEffect(() => {
  //   const savedTodoLists = localStorage.getItem("todoListDataSave");
  //   if (savedTodoLists) {
  //     setTodoListData(JSON.parse(savedTodoLists));
  //   }
  // }, []);

  const saveNewDimensions = (idToSearch, newData) => {
    const newTodoListData = todoListData.map((x) => {
      if (x.id === idToSearch) {
        if (newData.width !== undefined) {
          return { ...newData, layer: x.layer };
        }
        return { ...newData, width: x.width, height: x.height, layer: x.layer };
      }
      return x;
    });
    setTodoListData(newTodoListData);
  };

  return (
    <div className="square-container">
      {todoListData
        .filter((sq) => sq.layer === currentPath[currentPathIndex].layer)
        .map((sdat) => (
          <TodoListRectangle
            key={sdat.id}
            data={sdat}
            saveNewDimensions={saveNewDimensions}
          />
        ))}
    </div>
  );
};

export default TodoListManager;
